



















helpers = require '../../../helpers.coffee'

view_model = {
  components:
    contactsPickerTextCsv: require '../picker/text_csv'

  methods:
    submit: ->
      EventsBus.$emit 'contacts-picker-text-csv-validate'

    saveSuccess: (response) ->
      Loader.off()

    saveFailure: (response) ->
      Loader.off()
      alertify.error this.$t('contacts_group.feedback.failOnCreate', { type: this.$t('contacts.label.contacts') })
      EventsBus.$emit 'contacts-picker-text-csv-errors', response.body

  created: ->
    EventsBus.$on 'contacts-picker-text-csv-publish', @save

  beforeDestroy: ->
    EventsBus.$off 'contacts-picker-text-csv-publish', @save
}

exports.default = view_model




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/picker/manually.vue